export default class InputTypeConfig{
  public placeholder: string = '';

  public isNumberInput: boolean = false;

  public isMultiline: boolean = false;
}
